import React, { useRef, useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = (props) => {
  const chartRef = useRef();
  const { chartData, textCenterValue, textCenter } = props;
  // const customPosition = (context) => {
  //   const { chart } = context;
  //   console.log("chattttt", context?.chart);
  //   return {
  //     x: 10,
  //     y: 100 - 10,
  //   };
  // };

  const options = {
    plugins: {
      // tooltip: {
      //   // xAlign: "right",
      //   // yAlign: "center",
      //   x: 390,
      //   enabled: true,
      //   callbacks: {
      //     label: function (context) {
      //       console.log("contextiss", context);
      //     },
      //   },
      // },
      htmlLegend: {
        // ID of the container to put the legend in
        containerID: "legend-container",
        pointStyle: "circle",
      },
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        textAlign: "center",
      },
    },
  };

  return (
    <div className="relative group  z-[1]">
      <Doughnut
        id="helloworld"
        data={{ labels: chartData?.labels, datasets: chartData?.datasets }}
        ref={chartRef}
        options={options}
        redraw={chartData?.redraw}
        // plugins={options?.plugins}
      />
      <div className="absolute top-1/2 left-1/2  font-bold text-[#104250] dark:text-ternary-text -translate-x-1/2 -translate-y-[60px]  z-[-1] flex flex-col items-center font-manRope">
        <span className="text-3xl ">{textCenterValue}</span>
        <span className="text-xl ">{textCenter}</span>
      </div>
    </div>
  );
};

export default React.memo(DoughnutChart);
